import styled from 'styled-components'
import {Button} from "@mui/material";

import MapOutlinedIcon from '@mui/icons-material/MapOutlined';

import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import CheckCircleOutlined from "@mui/icons-material/CheckCircleOutlined";
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import { StyledButton } from 'components/Buttons/DefaultButton/DefaultButton.styles';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  background-color: white;
  overflow: auto;
  padding: 0 1rem;
  align-items: stretch; 
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 1.275rem 1rem;
    border-radius: 8px;
    background-color: #F3F6F7;
    margin-bottom: 1rem;
    min-width: 0;
    flex-direction: column;
`

export const PopupContainer = styled.div`
    padding: 1.5rem 1rem;
    border-radius: 8px;
    background: white;
    max-width: 25.75rem;
    width: 100%;
    align-self: center;
`

export const TitleContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 8px;
    background: var(--background-success, #F1F7FF);
    margin-bottom: 1rem;
`

export const Title = styled.div`
    margin-bottom: 8px;
    font-size: 1rem;
    line-height: 1.3;
    color: #000;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    @media (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`

export const SubtitleSecondary = styled.div`
    display: flex;
    align-items: center;
    font-size: var(--typography-body2-size);
    line-height: 1.3;
    font-weight: 400;
    color: #000;
    opacity: 60%;
    margin-top: 0.5rem;
`

export const ShiftBox = styled.div`
    display: flex;
    flex-direction: column;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 143%;
    letter-spacing: 0.15px;
    @media (min-width: 768px) {
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
        gap: 4rem;
    }
    @media (min-width: 1200px) {
        gap: 8rem;
    }
`

export const ShiftBoxDate = styled.div`
    padding-right: 2rem;
    display: flex;
    align-items: center;
    font-size: 1rem;
    @media (min-width: 768px) {
        font-size: var(--typography-h5-size);
    }
`

export const ButtonBox = styled.div`
display: flex;
padding-top: var(--1, 0.5rem);
align-items: center;
gap: 8px;
align-self: stretch;
flex-wrap: wrap; 
flex-grow: 1; 
`

export const DefaultButton = styled(Button)`
    border-radius: var(--borderRadius, 8px);
    background: var(--common-white-main, #FFF);
    display: flex;
    padding: var(--2, 1rem);
    justify-content: center;
    align-items: center;
    flex: 1 0 0;

    color: var(--text-primary, rgba(0, 0, 0, 0.87));
    font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: var(--3, 1.5rem);
    letter-spacing: 0.4px;
    flex-direction: row;
    text-transform: none;
    gap: 0.5rem;
`

export const ShiftBoxDateTimeInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    position: relative;
    padding-left: 1rem;
    
    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 5px;
        background-color: var(--secondary-main, #0B4598);
        border-radius: 2.5px;
    }
`

export const ShiftBoxRateContainer = styled.div`
`
export const ShiftBoxRateValueWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
`
export const ShiftBoxRate = styled.div`
display: flex;
margin-top: 1rem;
flex-direction: column;
@media (min-width: 768px) {
    align-items: start;
    margin-top: 0;
}
`

export const ShiftBoxRateTitle = styled.div`
font-size: 1rem;
line-height: 1.3;
color: #000;
font-weight: 600;
`
export const ShiftBoxRateValue = styled.div`
font-size: var(--typography-h5-size);
line-height: 1.3;
color: var(--secondary-main, #0B4598);
font-weight: 600;
vertical-align: top;
@media (min-width: 768px) {
    font-size: var(--typography-h4-size);
}
`
export const ShiftBoxRateDescription = styled.div`
font-size: 0.75rem;
line-height: 1.3;
font-weight: 500;
color: #000;
margin-top: 0.5rem;
`

export const ProposedRateDescription = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    line-height: 1.3;
    font-weight: 400;
    color: #000;
    opacity: 60%;
    a {
        display: contents;
        text-decoration: underline;
    }
    @media (min-width: 768px) {
        display: none;
    }
`


export const ShiftBoxContainer = styled.div`
    padding: 1.275rem 1rem;
    border-radius: 8px;
    margin-bottom: 1rem;
`
export const ContentTitle = styled.div`
    text-align: center;
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.3;
    color: rgb(0,0,0,0.7);
    margin: 0 1rem 0.5rem 1rem;
`

export const EndorsmentsBox = styled.div`
    display: flex;
    flex-direction: row;
`

export const Description = styled.div`
display: flex;
flex-direction: column;
font-size: 0.75rem;
line-height: 1.3;
font-weight: 400;
color: #000;
opacity: 60%;
a{
    text-decoration: underline;
}
@media (min-width: 768px) {
    flex-direction: row;
    a {
        margin-left: 0.2rem
    }
}
`

export const ShiftTimeDescription = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    line-height: 1.3;
    font-weight: 400;
    color: #000;
    opacity: 60%;
    background-color: #F3F6F7;
    padding: 0.75rem;
    border-radius: 8px;
    margin-top: 0.5rem;
    
    a {
        text-decoration: underline;
    }
    
    @media (min-width: 768px) {
        a {
            margin-left: 0.2rem
        }
        max-width: 50%
    }
`

export const ModalButtons = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    bottom: 0;
    margin: 1rem 0;
`

export const OutlinedButton = styled(Button)`
background: none;
border-color: var(--secondary-main, #0B4598) !important;
display: flex;
justify-content: center;
align-items: center;

color: var(--secondary-main, #0B4598) !important;
font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
font-style: normal;
font-weight: 100 !important;
letter-spacing: 0.4px;
flex-direction: row;
text-transform: none;
border-radius: 50px;
`

export const ContainedButton = styled(Button)`
background: ${
    props => props.disabled
    ? '#E0E0E0' 
    : 'var(--secondary-main, #0B4598)'
} !important;
display: flex;
justify-content: center;
align-items: center;

color: ${
    props => props.disabled
    ? 'rgba(0, 0, 0, 0.38)' 
    : '#fff'
} !important;
font-family: var(--fontMain, 'Poppins', sans-serif),sans-serif;
font-style: normal;
font-weight: 100 !important;
letter-spacing: 0.4px;
flex-direction: row;
text-transform: none;
margin-bottom: 0.5rem;
border-radius: 50px;
`

export const StickyButtonContainer = styled.div`
    margin-bottom: 3rem;
    text-align: center;
    
    @media only screen and (max-width: 600px) {
        margin-bottom: 7.5rem;
    }
`;

export const PageWithStickyFooter = styled(Page)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const PageContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const CheckMark = styled(CheckCircleOutlined)`
    width: 1.5rem;
    margin: 0 1rem;
`

export const SafetyGuidelines = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`

export const Subtitle = styled.div`
    font-size: var(--font-size-mid);
    line-height: 1.3;
    color: #000;
    font-weight: 400;
    opacity: 60%;
    @media only screen and (max-width: 600px) {
        font-size: var(--typography-body2-size);
    }
`
export const UnpaidGap = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    color: red;
    font-weight: 500;
    margin: 1rem;
`

export const PartialOfferSubtitle = styled(Description)`
display: flex;
flex-direction: row;
justify-content: start;
align-items: center;
color: black !important;
margin: 0.25rem 0 0 0 !important;
`